module.exports = __webpack_public_path__ + "static/semantic-image-fluid-e2edf0044a712c1888da69de87018cde.png";